import { DocViewerRenderers as CoreRenderers } from "@cyntler/react-doc-viewer";
import { TIFFRenderer } from "./TIFFRenderer";
import { PDFRenderer } from "./PDFRenderer";
import { UnsupportedRenderer } from "./UnsupportedRenderer";

// override built-in TIFF renderer as it lacks full TIFF support
export const DocViewerRenderers = [
  ...CoreRenderers,
  TIFFRenderer,
  PDFRenderer,
  UnsupportedRenderer,
];
